import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LanguageService } from './language.service';

@Component({
  selector: 'app-language-toggle',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
  template: `
    <button
      mat-icon-button
      (click)="languageService.toggleLanguage()"
      [matTooltip]="languageService.currentLanguage === 'es' ? 'Switch to English' : 'Cambiar a Espanol'"
      [attr.aria-label]="languageService.currentLanguage === 'es' ? 'Switch to English' : 'Cambiar a Espanol'"
      class="lang-toggle-btn"
    >
      <mat-icon  aria-hidden="true">{{ iconGlobe }}</mat-icon>
      <span class="lang-label">{{ languageService.currentLanguage === 'es' ? 'EN' : 'ES' }}</span>
    </button>
  `,
  styles: [`
    .lang-toggle-btn {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 12px;
    }
    .lang-label {
      font-size: 11px;
      font-weight: 600;
    }
  `]
})
export class LanguageToggleComponent {
  languageService = inject(LanguageService);
  iconGlobe = 'language';
}
